"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require("react-router");

var _ButtonsGroup = require("./ButtonsGroup");

var _ButtonsGroup2 = _interopRequireDefault(_ButtonsGroup);

var _config = require("../../config");

var _config2 = _interopRequireDefault(_config);

var _MigrationBoxFooter = require("./MigrationBoxFooter.scss");

var _MigrationBoxFooter2 = _interopRequireDefault(_MigrationBoxFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MigrationBoxFooter = function (_React$Component) {
  (0, _inherits3.default)(MigrationBoxFooter, _React$Component);

  function MigrationBoxFooter() {
    (0, _classCallCheck3.default)(this, MigrationBoxFooter);
    return (0, _possibleConstructorReturn3.default)(this, (MigrationBoxFooter.__proto__ || (0, _getPrototypeOf2.default)(MigrationBoxFooter)).apply(this, arguments));
  }

  (0, _createClass3.default)(MigrationBoxFooter, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: _MigrationBoxFooter2.default.footer },
        _react2.default.createElement(
          _ButtonsGroup2.default,
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            { to: _config2.default.forumBaseUrl, target: "_blank", rel: "noopener noreferrer" },
            "Contact Support"
          ),
          _react2.default.createElement(
            "a",
            { href: _config2.default.forumBaseUrl, target: "_blank", rel: "noopener noreferrer" },
            "Learn More"
          )
        )
      );
    }
  }]);
  return MigrationBoxFooter;
}(_react2.default.Component);

exports.default = MigrationBoxFooter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/MigrationBoxFooter.jsx
// module id = 1276
// module chunks = 0